'use client';

import Link from 'next/link';
import Image from 'next/image';
import { Mail, MapPin } from 'lucide-react';
import { getZakelijkUrl } from '@/lib/urls';
import { DynamicLink } from './DynamicLink';

export function ConsumerFooter() {
  return (
    <footer className="bg-ink text-white">
      <div className="container-site section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <Image
                src="/images/logo.svg"
                alt="ValBewust"
                width={250}
                height={60}
                className="h-12 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-white/70 mb-6">
              Samen werken aan een veilige thuisomgeving voor ouderen.
            </p>
            <div className="flex gap-4">
              <Link href="https://apps.apple.com/nl/app/valbewust/id6759345024" target="_blank" rel="noopener noreferrer" className="bg-white/10 hover:bg-white/20 rounded-lg px-4 py-2 text-sm transition-colors">
                App Store
              </Link>
              <Link href="https://play.google.com/store/apps/details?id=nl.valbewust.thuis&pcampaignid=web_share" target="_blank" rel="noopener noreferrer" className="bg-white/10 hover:bg-white/20 rounded-lg px-4 py-2 text-sm transition-colors">
                Google Play
              </Link>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <p className="font-semibold text-lg mb-4">Voor u</p>
            <ul className="space-y-3">
              <li>
                <Link href="/#app" className="text-white/70 hover:text-white transition-colors">
                  De App
                </Link>
              </li>
              <li>
                <Link href="/#features" className="text-white/70 hover:text-white transition-colors">
                  Hoe het werkt
                </Link>
              </li>
              <li>
                <Link href="/blog" className="text-white/70 hover:text-white transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link href="/contact" className="text-white/70 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Professional Link */}
          <div>
            <p className="font-semibold text-lg mb-4">Voor Professionals</p>
            <ul className="space-y-3">
              <li>
                <DynamicLink getHref={() => getZakelijkUrl()} className="text-white/70 hover:text-white transition-colors">
                  Zakelijk Portaal
                </DynamicLink>
              </li>
              <li>
                <DynamicLink getHref={() => getZakelijkUrl('/pakketten')} className="text-white/70 hover:text-white transition-colors">
                  Pakketten & Prijzen
                </DynamicLink>
              </li>
              <li>
                <DynamicLink getHref={() => getZakelijkUrl('/contact')} className="text-white/70 hover:text-white transition-colors">
                  Word Partner
                </DynamicLink>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="font-semibold text-lg mb-4">Contact</p>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-white/70">
                <Mail size={18} />
                <span>info@valbewust.nl</span>
              </li>
              <li className="flex items-start gap-3 text-white/70">
                <MapPin size={18} className="mt-1" />
                <span>Kornalijnstoep 34<br />9403 RX Assen</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm">
            &copy; {new Date().getFullYear()} ValBewust i.o. Alle rechten voorbehouden.
          </p>
          <div className="flex gap-6 text-sm">
            <Link href="/privacy" className="text-white/50 hover:text-white transition-colors">
              Privacybeleid
            </Link>
            <Link href="/voorwaarden" className="text-white/50 hover:text-white transition-colors">
              Algemene voorwaarden
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
